import { logger } from '@luna/logger';
import { createSingleton } from '@luna/utils';

import { createIframe } from './IframeService';
import type { OidcConfig, WindowWithRpSdk } from '../types';
import { OP_IFRAME_ELEMENT_ID, RP_IFRAME_ELEMENT_ID } from '../types';

const windowWithRpSdk = window as WindowWithRpSdk;
const EVT_OP_STATE_CHANGED = 'EvtOpStateChanged';

const { set: setOidcConfig } = createSingleton<OidcConfig>();

export const initOidcSessionManagement = (config: OidcConfig) => {
    const publicUrl = config?.publicUrl || '';
    setOidcConfig(config);

    window.addEventListener(
        'message',
        (e) => {
            if (e.origin !== window.location.origin) {
                logger.debug('[RP_CALLBACK] ignoring event from foreign origin', e);
                return;
            }

            // filter out devtools messages spamming console
            if (e.data?.source === 'react-devtools-bridge') {
                return;
            }
            logger.trace('[RP_CALLBACK] event', e);
            if (e.data.id === EVT_OP_STATE_CHANGED) {
                config.onSessionChanged();
            }
        },
        false,
    );
    windowWithRpSdk.rpSdk = {
        baseFederatedLoginUrl: config.baseFederatedLoginUrl,
        clientId: config.clientId,
        sessionState: config.sessionState ?? '',
        strategy: config.strategy,
    };
    windowWithRpSdk.RP_SDK = {
        RP_IFRAME_PARAMS: {
            CLIENT_ID: config.clientId,
            OP_BASE_FQDN: config.baseFederatedLoginUrl,
            SESSION_STATE: config.sessionState ?? '',
        },
    };

    createIframe({
        id: OP_IFRAME_ELEMENT_ID,
        src: config.opIframe,
    });
    createIframe({
        id: RP_IFRAME_ELEMENT_ID,
        src: `${window.location.origin}${publicUrl}/oidc-sm/rp-iframe/`,
    });
};
